
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directory/companies",
      function () {
        return require("private-next-pages/directory/companies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directory/companies"])
      });
    }
  